import {ComponentProps} from 'react'
import PlaceholderSearchResults from "./PlaceholderSearchResults";

export const docProps : ComponentProps<typeof PlaceholderSearchResults> = {}

export default PlaceholderSearchResults;
